import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { GenericDialog } from 'src/shared/components/organisms/genericDialog';
import { DateHelper } from 'src/shared/helpers/dateHelper';
import { useGlobals } from 'src/shared/contexts/appContext';
import { HelpArticleBody } from 'src/modules/help/components/helpArticleBody';
import { HelpPageVersion } from '../models/helpPageVersion';
import { replaceHelpPageTerms } from '../functions/helpPageTerms';

type HelpPageVersionPreviewDialogProps = {
  version: HelpPageVersion | null;
  onClose: () => void;
};

export const HelpPageVersionPreviewDialog = (props: HelpPageVersionPreviewDialogProps) => {
  const { version, onClose } = props;
  const { t } = useTranslation(['helpArticles']);
  const { currentUser } = useGlobals();

  if (!version) return null;

  // Innehållet visas som i hjälpcentret, med den inloggades benämningar. Infotexten bara när artikeln har sådana taggar.
  const hasTerms = replaceHelpPageTerms(version.bodyHtml, currentUser?.mainSettings ?? []) !== version.bodyHtml;

  return (
    <GenericDialog
      open={!!version}
      onClose={onClose}
      onSave={onClose}
      showDialogActions={false}
      maxWidth='md'
      dialogTitle={version.title}
      dialogSubTitle={`${t('helpArticles:versions.previewTitle', { versionNumber: version.versionNumber })} · ${
        version.createdBy
      } · ${DateHelper.getDateTime(version.createdAt)}`}
      dialogContent={
        <Box>
          {version.changeSummary && (
            <Typography variant='body2' color='text.secondary' sx={{ mb: 2, fontStyle: 'italic' }}>
              {version.changeSummary}
            </Typography>
          )}
          {hasTerms && (
            <Typography variant='body2' color='text.secondary' sx={{ mb: 2 }}>
              {t('helpArticles:versions.termsInfo', { customer: currentUser?.customerName })}
            </Typography>
          )}
          <HelpArticleBody bodyHtml={version.bodyHtml} />
        </Box>
      }
    />
  );
};
